<template>
  <app-modal name="create-directory-modal" :title="title" @before-open="beforeOpen" @before-close="beforeClose" width="30%" @on-ok="onOk">
    <p class="field-desc">
      {{$t('directory.desc')}}
    </p>
    <app-form
      ref="form"
      @on-submit="onSubmit"
      :schema="schema"
      :data="formModel"
    />
    <p class="field-desc">
      {{$t('directory.parentDesc')}}
    </p>
  </app-modal>

</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import { mapFormOptions } from '@/components/app-form/form-helper';
import { getDirectoryOptions, getDirectoryStructure, setDirectoryStructure } from '@/utils/directory';
import DirectoryProxy from '@/store/proxies/directory-proxy';

export default {
  name: 'CreateDirectoryModal',
  components: {
    AppForm,
    AppModal,
  },
  data() {
    return {
      title: this.$t('directory.addDirectory'),
      directoryStructure: [],
      directoryFlatStructure: {},
      directoryOptions: [],
      schema: [
        {
          name: 'name',
          label: this.$t('directory.name'),
          placeholder: `${this.$t('app.enter')} ${this.$t('directory.name')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'parent',
          label: this.$t('directory.parentDir'),
          placeholder: `${this.$t('app.enter')} ${this.$t('directory.parentDir')}`,
          type: 'select',
          options: [],
        },
      ],
      formModel: {
        name: '',
        parent: '',
      },
    };
  },
  mounted() {

  },
  watch: {
    ...mapFormOptions.bind(this)([
      { name: 'parent', key: 'options', value: 'directoryOptions' },
    ]),
  },
  methods: {
    onSubmit(formModel) {
      const vm = this;
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          new DirectoryProxy().createDir({
            name: formModel.name,
            parent_id: formModel.parent,
          }).then(({ new_directory }) => {
            const newDir = {
              id: new_directory.id,
              name: formModel.name,
              expand: true,
              active: false,
              children: [],
              parentId: new_directory.parent_id,
            };
            if (formModel.parent) {
              vm.directoryFlatStructure[formModel.parent].children.push(newDir);
            } else {
              vm.directoryStructure.push(newDir);
            }
            setDirectoryStructure(vm.directoryStructure);
            new DirectoryProxy().updateDirStructure(vm.directoryStructure).then(() => {
              vm.$bus.emit('refresh-app-directory');
              vm.$modal.hide('create-directory-modal', { isOk: true });
            });
          });
        }
      });
    },
    onOk() {
      this.$refs.form.submit();
    },

    beforeClose() {
      this.formModel = {
        name: null,
        parent: null,
      };
    },
    beforeOpen(params) {
      const vm = this;
      this.title = params.model.id ? this.$t('directory.editDirectory') : this.$t('directory.createDirectory');
      this.directoryStructure = getDirectoryStructure();
      this.directoryOptions = getDirectoryOptions(vm.directoryStructure, (dir) => {
        vm.directoryFlatStructure[dir.id] = dir;
      });
      if (params.model.id) {
        this.formModel = {
          id: params.model.id,
          name: params.model.name,
          parent: params.model.parentId,
        };
      }
    },
  },
};
</script>
<style scoped>
.left-col {
  width: 35%;
}
.right-col {
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/directory-list/create-directory-modal.vue